<script>
import { settings } from '@/model/gantt/ganttUtils';

export default {
  name: 'GanttBar',
  props: {
    item: Object,
  },
  computed: {
    settings() { return settings; },
    type() { return this.item.self['@type'].toLowerCase(); },
    barSettings() { return settings.bar[this.type]; },
    color() {
      if (this.type === 'task' && this.item.self.isClosed) {
        return 'grey';
      }

      return this.barSettings.fill;
    },
    h() { return this.barSettings.h; },
    x() { return this.item.x + settings.bar.circle.padding / 2; },
    y() { return this.item.y + settings.bar.hover.h / 2 - this.h / 2; },
    w() { return this.item.w - settings.bar.circle.padding; },
    id() { return this.item.self['@id']; },
    r() { return this.h / 2 - 1; },
    xs() { return this.x + this.r + 1; },
    xf() { return this.x + this.w - this.r - 1; },
    isEditable() { return this.item.self.isEditable; },
  },
  methods: {
    drag(type) {
      if (this.type === 'stage' && type !== 'center') return;
      if (!this.isEditable) return;
      this.$emit('drag', { item: this.item, type });
    },
    mouseup() {
      if (!this.isEditable) return;
      if (this.type === 'stage') return;
      this.$emit('mouseup');
    },
    bind(isStart) {
      this.$emit('bind', { isStart, id: this.item.self['@id'] });
    },
  },
};
</script>

<template lang="pug">
  g(:data-id="id" :class="{ isEditable, [type]: true }" @mouseenter="$emit('enter')" @mouseleave="$emit('leave')")
    //rect(:x="x" :y="y" :height="h" :width="10" :style="{ fill: 'green' }" :rx="h / 2" :ry="h / 2" @mousedown="$emit('drag', { id, type: 'start' })" class="edge")
    //rect(:x="x" :y="y" :height="h" :width="w" :style="{ fill }" :rx="h / 2" :ry="h / 2" @mousedown="$emit('drag', { id, type: 'center' })")
    //rect(:x="x + w - 10" :y="y" :height="h" :width="10" :style="{ fill: 'green' }" :rx="2" :ry="20" @mousedown="$emit('drag', { id, type: 'finish' })" class="edge")
    //rect(:x="item.x" :y="item.y" :height="settings.bar.hover.h" :width="item.w")
    rect(:x="x" :y="y" :height="h" :width="w" :fill="color" :rx="r" :ry="r" @mousedown.stop="drag('center')" @mouseup="mouseup")
    path.edge(:d="`M${xs},${y + 1} a${r},${r} 0 0,0 0,${h - 2}`" :fill="color" @mousedown.stop="drag('start')")
    path.edge(:d="`M${xf},${y + 1} a${r},${r} 0 0,1 0,${h - 2}`" :fill="color" @mousedown.stop="drag('finish')")
    circle(v-if="type === 'task'" :r="settings.bar.circle.r" :cx="item.x - settings.bar.circle.padding" :cy="item.y + settings.bar.hover.h / 2" :fill="color" @click.stop="bind(true)" @mousedown.stop)
    circle(v-if="type === 'task'" :r="settings.bar.circle.r" :cx="item.x + item.w + settings.bar.circle.padding" :cy="item.y + settings.bar.hover.h / 2" :fill="color" @click.stop="bind(false)" @mousedown.stop)
    //text(:x="x" :y="y") {{ settings }}
</template>

<style scoped lang="scss">
  circle {
    cursor: pointer;
  }

  rect, path {
    cursor: default;
  }

  .edge:hover {
    cursor: default;
  }

  .isEditable rect, path {
    cursor: pointer;
  }
 .isEditable:not(.stage) .edge:hover {
   cursor: ew-resize;
 }
</style>
